import { useFormik } from "formik";
import { TextMediumXS } from "../../../../Components/Text/MediumText";
import { NuInputSetting } from "../../../../Components/Utils/Input";
import axiosInstance from "../../../../Services/axiosCommon";
import { useToast } from "../../../../Components/Others/ToastServices";
import { useEffect, useState } from "react";
import * as yup from 'yup';
import { notification } from "antd";


const Equipment = ({id}) => { 
  const [data, setData] = useState([]);
  const toast = useToast();
        const [selectedFile, setSelectedFile] = useState(null);
      const [api, contextHolder] = notification.useNotification();
  
  const [createNew, setCreateNew] = useState({
    categoryId: "",
    name: ""
  });

  

 const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema:yup.object({

      }),
      onSubmit: (value,{resetForm}) => {
      value.categoryId = id

      let formData = new FormData();
      formData.append("json_data", JSON.stringify(value));
   if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("equipmentImage", file);
        });
      } else {
        formData.append("equipmentImage", []);
      }
      // addFormData("/equipments/new-equipment", formData, resetForm);
         axiosInstance.post(`/equipments/new-equipment`,formData,resetForm)
              .then(res => {               
                  if (res.data) {
                      console.log("Created", resetForm)
                      resetForm();
                      GetData(id);
                      toast.open({
                        type:"success",
                        message: `Equipment  Added successfully`,
                        // description:'',
                        // placement: 'bottomRight',
                    });
                  }
                  else {
                      console.log("Failed")
                      toast.open({
                        type:"error",
                        message: `Equipment Added failed`,
                        // description: response.data.msg || 'Network error',
                        // placement: 'bottomRight',
                    });
                  }
              })
      },
    });
 const GetData = (id) => {
  axiosInstance.get(`/equipments/list?categoryId=${id}`)
    .then(res => {
      console.log("equipment list res", res.data?.data);
      let fetchedEquipments = res.data?.data?.data || [];
      setData(fetchedEquipments);
    })
    .catch(err => {
      console.log("error", err);
    });
};


const handleDelete = (value,id) => {
  axiosInstance.delete(`/equipments/${value}`)
    .then(res => {
      if (res?.status == 200) {
        GetData(id);
        toast.open({
          type:"success",
          message: `Equipment  Deleted successfully`,
          // placement: 'bottomRight',
        });
      }
      else {
        console.log("Failed")
        toast.open({
          type:"error",
          message: `Equipment Deleted failed`,
          // placement: 'bottomRight',
        });
      }
    })
}

useEffect(() => {
  GetData(id);
}, [id])
  return (
    <div className=" w-full">
      <form onSubmit={formik.handleSubmit}>
        <div className={`w-full text-xs`}>
          <div className="px-3 mb-1">
            <label className="font-medium text-textColor-500">
               Equipment
            </label>
            <NuInputSetting
              type="text"
              placeholder="Name"
              formik={formik}
              name="name"
            />
          </div>
        </div>
      </form>
      <div className=" px-3">
        <div className="w-full rounded-lg h-44 bg-[#f5f3ff] border border-gray-300 overflow-x-hidden overflow-y-auto">
         <ul>
  {Array.isArray(data) && data.map((List, idx) => (
    <li
      key={idx}
      className="m-1 flex justify-between items-center text-xs bg-white border border-gray-300 rounded text-main-title py-2 px-2 hover:bg-[#B3EBD7] hover:bg-opacity-50"
    >
      <TextMediumXS color="text-[#697565]" content={List?.name || "-"} />
      {List?.id && (
        <span
          onClick={() => handleDelete(List?.id, List?.categoryId)}
          className="text-blue-900 cursor-pointer"
        >
          x
        </span>
      )}
    </li>
  ))}
</ul>

        </div>
      </div>
    </div>
  );
};

export default Equipment;


